// extracted by mini-css-extract-plugin
export default {"progress":"EducationManagement_progress__8vQjr"};